import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export const useLoginOut = () => {
  const navigate = useNavigate();

  const loginOut = useCallback(() => {
    localStorage.clear();
    navigate("/login");
  }, []);

  return { loginOut };
};
